import ExerciseStore from '../storage/ExerciseStore.js'
import WorkoutStore from '../storage/WorkoutStore.js'

class WorkoutView extends HTMLElement {

  #lastExerciseId = null

  refresh() {
    this.#render()
  }

  #render() {
    const workout = WorkoutStore.getCurrent()

    const grouped = ExerciseStore.getAllByType()

    const strengthSection = this.querySelector("[data-type='strength']")
    const stretchSection  = this.querySelector("[data-type='stretch']")
    const cardioSection   = this.querySelector("[data-type='cardio']")
    const strengthList    = strengthSection.querySelector("ul")
    const stretchList     = stretchSection.querySelector("ul")
    const cardioList      = cardioSection.querySelector("ul")

    strengthList.innerHTML = ""
    stretchList.innerHTML  = ""
    cardioList.innerHTML   = ""

    const exercises = grouped["strength"] || []
    exercises.forEach((exercise) => {
      strengthList.appendChild(this.#buildItem(exercise, workout && workout.hasCompleted(exercise.id)))
    })

    const stretches = grouped["stretch"] || []
    stretches.forEach((exercise) => {
      stretchList.appendChild(this.#buildItem(exercise, workout && workout.hasCompleted(exercise.id)))
    })

    const cardios = grouped["cardio"] || []
    cardios.forEach((exercise) => {
      cardioList.appendChild(this.#buildItem(exercise, workout && workout.hasCompleted(exercise.id)))
    })

    if (exercises.length === 0) {
      strengthSection.setAttribute("hidden", "")
    }
    else {
      strengthSection.removeAttribute("hidden")
    }

    if (stretches.length === 0) {
      stretchSection.setAttribute("hidden", "")
    }
    else {
      stretchSection.removeAttribute("hidden")
    }

    if (cardios.length === 0) {
      cardioSection.setAttribute("hidden", "")
    }
    else {
      cardioSection.removeAttribute("hidden")
    }
  }

  #buildItem(exercise, completed) {
    const template         = this.querySelector("template")
    const documentFragment = template.content.cloneNode(true)
    const item             = documentFragment.firstElementChild

    item.id = exercise.id
    item.querySelector("h4").textContent = exercise.exerciseName
    if (completed) {
      item.setAttribute("completed", "")
    }

    const listItem = document.createElement("li")
    listItem.appendChild(documentFragment)
    return listItem
  }

  #startExercise = (event) => {
    const button = event.target.closest("[data-start-exercise]")
    if (!button) return
    const workoutExercise = button.closest("gime-workout-exercise")
    if (workoutExercise.hasAttribute("completed")) return
    const exercise = ExerciseStore.get(workoutExercise.id)
    if (!exercise) return
    this.#lastExerciseId = exercise.id
    this.setAttribute("mode", "performing")
    this.querySelector("gime-perform-exercise").show(exercise)
  }

  #exerciseDone = () => {
    this.removeAttribute("mode")
    this.#render()
    if (this.#lastExerciseId) {
      const element = document.getElementById(this.#lastExerciseId)
      if (element) {
        element.scrollIntoView({ behavior: "instant", block: "center" })
      }
    }
  }

  connectedCallback() {
    this.addEventListener("click", this.#startExercise)
    this.querySelector("gime-perform-exercise").addEventListener("gime-exercise-done", this.#exerciseDone)
    this.#render()
  }
}

export default WorkoutView
